import React from "react";
import { Route, Switch } from "react-router-dom";
import { FeatureFlag, On } from "../Libs/FeatureFlag";

import AuthenticatedRoute from "./AuthenticatedRoute";
import AdminRoute from "./AdminRoute";
import WebFormRoute from "./WebFormRoute";
import NotFound from "../Containers/NotFound";
import { FormList, WebForm } from "../Features/WebForms";
import { QMResultsPage } from "../Features/QMResults";
import DecommissionedPage from "./DecommissionedPage/DecomissionedPage";

export default function Routes({ appProps }) {
	return (
		<React.Fragment>
			<Switch>
				<AuthenticatedRoute
					path="/"
					exact
					component={DecommissionedPage}
					appProps={appProps}
				/>
				<AuthenticatedRoute
					path="/VideoChannel"
					exact
					component={DecommissionedPage}
					appProps={appProps}
				/>
				<AuthenticatedRoute
					path="/VideoChannel/:videoId"
					exact
					component={DecommissionedPage}
					appProps={appProps}
				/>
				<AdminRoute path="/VideoManager" exact component={DecommissionedPage} />
				<AdminRoute
					path="/VideoManager/:videoId"
					exact
					component={DecommissionedPage}
				/>
				<AuthenticatedRoute
					path="/Recognition"
					exact
					component={DecommissionedPage}
					appProps={appProps}
				/>
				<AdminRoute path="/Reporting" exact component={DecommissionedPage} />
				<AuthenticatedRoute
					path="/QMResults"
					exact
					component={QMResultsPage}
					appProps={appProps}
				/>
				<AuthenticatedRoute
					path="/WebForm"
					exact
					component={FormList}
				/>
				<WebFormRoute
					path="/WebForm/:formId"
					exact
					component={WebForm}
				/>
				{/* Finally, catch all unmatched routes */}
				<Route component={NotFound} />
			</Switch>
		</React.Fragment>
	);
}
